import { lazy } from 'react'
import reducer from './state/reducers'
import { getStore } from '@AppRedux/store'

const store = getStore();

const LoginScreen = lazy(() =>
    import('./LoginScreen').then(async module => {
        store.injectReducer('loginForm', reducer.loginReducer)
        return module
    })
);

const ApplicantDetail = lazy(() =>
    import('./ApplicantStatus').then(async module => {
        store.injectReducer('statusForm', reducer.statusReducer)
        return module
    })
);

const Accepted = lazy(() => import('./Accepted'));

const Denied = lazy(() => import('./Denied'));

const AlreadyResponded = lazy(() => import('./AlreadyResponded'));

const TokenExpired = lazy(() => import('./TokenExpired'));

export const routes = [
    {
        path: '/apply',
        component: LoginScreen,
        exact: true,
        public: true,
    },
    {
        label: 'Status Of Application',
        path: '/ApplicantStatus',
        component: ApplicantDetail,
        exact: true,
        public: true,
    },
    {
        path: '/apply/accepted',
        component: Accepted,
        exact: true,
        public: true,
    },
    {
        path: '/apply/denied',
        component: Denied,
        exact: true,
        public: true,
    },
    {
        path: '/apply/alreadyresponded',
        component: AlreadyResponded,
        exact: true,
        public: true,
    },
    {
        path: '/apply/tokenexpired',
        component: TokenExpired,
        exact: true,
        public: true,
    },
]